// useChatSlashCommands — the composer's `/`-slash quick actions. Each command's
// whole contract is its `insertText`: picking one seeds the draft with a
// ready-to-send prompt the author can edit, `@`-ground, and send, so the backing
// behaviour is the real turn pipeline. Kept to the assistant's core,
// honestly-supported moves. A hook because the copy uses the lingui `t` macro.

import { useLingui } from "@lingui/react/macro";
import type { ComposerSlashCommand } from "../../components/Composer/PowerComposer/types.js";

export const useChatSlashCommands = (): readonly ComposerSlashCommand[] => {
    const { t } = useLingui();
    return [
        {
            id: "summarise",
            label: t`Summarise`,
            description: t`Summarise the key points`,
            insertText: t`Summarise the key points.`,
        },
        {
            id: "questions",
            label: t`Practice questions`,
            description: t`Create practice questions`,
            insertText: t`Create practice questions.`,
        },
        {
            id: "improve",
            label: t`Improve`,
            description: t`Suggest improvements`,
            insertText: t`Suggest improvements.`,
        },
        {
            id: "explain",
            label: t`Explain`,
            description: t`Explain this in simple terms`,
            insertText: t`Explain this in simple terms.`,
        },
    ];
};
